import DialogModal from './DialogModal'

export { DialogModalV2 } from './DialogModalV2/DialogModalV2'
export default DialogModal
